import { AnnotationAlignment, Connector, ConnectorModel, ContextMenuItemModel, Diagram, DiagramBeforeMenuOpenEventArgs, HorizontalAlignment, IDragEnterEventArgs, IRotationEventArgs, ISelectionChangeEventArgs, ISizeChangeEventArgs, NodeConstraints, NodeModel, PathAnnotationModel, SelectorModel, ShapeAnnotationModel, TextAlign, TextStyleModel, VerticalAlignment } from "@syncfusion/ej2-angular-diagrams";
import { PathAnnotation, ShapeAnnotation } from '@syncfusion/ej2-diagrams'
import { NodeProperties, SelectorViewModel } from "./selector";
import { ChangeArgs as ButtonChangeArgs, ChangeEventArgs as CheckBoxChangeEventArgs, } from '@syncfusion/ej2-angular-buttons'
import { ColorPickerEventArgs } from "@syncfusion/ej2-angular-inputs";
import { DropDownListComponent } from "@syncfusion/ej2-angular-dropdowns";



export class DiagramClientSideEvents {

    private selectedItem: any;
    public ddlTextPosition: any;
    constructor(selectedItem: SelectorViewModel) {
        this.selectedItem = selectedItem;

    }
    public drawingNode: any;
    public selectionChange(args: ISelectionChangeEventArgs): void {
        if (args.state === 'Changed') {
            let diagram = this.selectedItem.diagram;
            let toolbarObj = this.selectedItem.toolbarObj;
            // let diagram = (document.getElementById('diagram') as any).ej2_instances[0];
            // let toolbarObj = (document.getElementById('toolbarEditor') as any).ej2_instances[0];
            var multiSelect;
            var selectedItems:any = diagram.selectedItems.nodes;
            this.selectedItem.utilityMethods.enableToolbarItems(selectedItems);
            var nodeContainer:any = document.getElementById('nodePropertyContainer');
            nodeContainer.classList.remove('multiple');
            nodeContainer.classList.remove('connector');
            if (selectedItems.length > 1) {
                multiSelect = true;
                this.multipleSelectionSettings(selectedItems as Object[]);
                toolbarObj.items[7].tooltipText = 'Group';
                toolbarObj.items[7].prefixIcon = 'sf-icon-group';
                for (var i = 7; i <= 25; i++) {
                    toolbarObj.items[i].visible = true;
                }
            }
            else if (selectedItems.length === 1) {
                multiSelect = false;
                this.singleSelectionSettings(selectedItems[0] as Object[]);
                for (var i = 7; i <= 25; i++) {
                    if (i <= 16) {
                        toolbarObj.items[i].visible = false;
                    }
                    else {
                        toolbarObj.items[i].visible = true;

                    }
                }
                if (selectedItems[0].children && selectedItems[0].children.length > 0) {
                    toolbarObj.items[7].tooltipText = 'UnGroup';
                    toolbarObj.items[7].prefixIcon = 'sf-icon-ungroup';
                    toolbarObj.items[7].visible = true;
                }
            }
            else {
                this.objectTypeChange('diagram');
                for (var i = 7; i <= 25; i++) {
                    toolbarObj.items[i].visible = false;
                }
            }
        }
    };
    public multipleSelectionSettings(selectedItems: Object[]): void {
        this.objectTypeChange('None');
        let showConnectorPanel: boolean = false, showNodePanel: boolean = false;
        let showTextPanel: boolean = false, showConTextPanel: boolean = false;
        let nodeContainer: any = document.getElementById('nodePropertyContainer');
        for (let i: number = 0; i < selectedItems.length; i++) {
            let object: Object = selectedItems[i];
            if ((object as ConnectorModel).type === undefined && (!showNodePanel || !showTextPanel)) {
                showNodePanel = true;
                showTextPanel = (object as any).annotations.length > 0 && (object as any).annotations[0].content ? true : false;
            } else if ((object as ConnectorModel).type !== undefined && (!showConnectorPanel || !showConTextPanel)) {
                showConnectorPanel = true;
                showConTextPanel = (object as any).annotations.length > 0 && (object as any).annotations[0].content ? true : false;
            }
        }
        let selectItem1: any = this.selectedItem.diagram.selectedItems;
        if (showNodePanel) {
            nodeContainer.style.display = '';
            nodeContainer.classList.add('multiple');
            if (showConnectorPanel) {
                nodeContainer.classList.add('connector');
            }
            this.selectedItem.utilityMethods.bindNodeProperties(selectItem1.nodes[0], this.selectedItem);
        }
      
        
        if (showTextPanel || showConTextPanel) {
            document.getElementById('textPropertyContainer')!.style.display = '';
            if (showTextPanel && showConTextPanel) {
                document.getElementById('textPositionDiv')!.style.display = 'none';
                document.getElementById('textColorDiv')!.className = 'col-xs-6 db-col-left';
            } else {
                document.getElementById('textPositionDiv')!.style.display = '';
                document.getElementById('textColorDiv')!.className = 'col-xs-6 db-col-right';
                if (showConTextPanel) {
                    this.ddlTextPosition.dataSource = this.selectedItem.textProperties.getConnectorTextPositions();
                    //this.selectedItem.utilityMethods.bindTextProperties(selectItem1.connectors[0].annotations[0].style, this.selectedItem);
                } else {
                    this.ddlTextPosition.dataSource = this.selectedItem.textProperties.getNodeTextPositions();
                    //this.selectedItem.utilityMethods.bindTextProperties(selectItem1.connectors[0].annotations[0].style, this.selectedItem);
                }
                this.ddlTextPosition.dataBind();
            }
        }
    };
    public singleSelectionSettings(selectedObject: Object): void {

        let object: any | ConnectorModel = null;
        if ((selectedObject as Connector).type === undefined) {
            this.objectTypeChange('node');
            object = selectedObject as any;
            this.selectedItem.utilityMethods.bindNodeProperties(object, this.selectedItem);
        } 
        
        if (object.shape && object.shape.type === 'Text') {
            document.getElementById('textPropertyContainer')!.style.display = '';
            document.getElementById('toolbarTextAlignmentDiv')!.style.display = 'none';
            document.getElementById('textPositionDiv')!.style.display = 'none';
            document.getElementById('textColorDiv')!.className = 'col-xs-6 db-col-left';
            this.selectedItem.utilityMethods.bindTextProperties(object.style, this.selectedItem);
        } else if (object.annotations.length > 0 && object.annotations[0].content) {
            document.getElementById('textPropertyContainer')!.style.display = '';
            let annotation: any | PathAnnotation = null;
            document.getElementById('toolbarTextAlignmentDiv')!.style.display = '';
            document.getElementById('textPositionDiv')!.style.display = '';
            document.getElementById('textColorDiv')!.className = 'col-xs-6 db-col-right';
            this.selectedItem.utilityMethods.bindTextProperties(object.annotations[0].style, this.selectedItem);
            this.selectedItem.utilityMethods.updateHorVertAlign(object.annotations[0].horizontalAlignment, object.annotations[0].verticalAlignment);
            if (object.annotations[0] instanceof ShapeAnnotation) {
                annotation = object.annotations[0] as ShapeAnnotation;
                this.ddlTextPosition.dataSource = this.selectedItem.textProperties.getNodeTextPositions();
                this.ddlTextPosition.value = this.selectedItem.textProperties.textPosition = null;
                this.ddlTextPosition.dataBind();
                this.ddlTextPosition.value = this.selectedItem.textProperties.textPosition = this.selectedItem.utilityMethods.getPosition(annotation.offset);
                this.ddlTextPosition.dataBind();
            } else if (object.annotations[0] instanceof PathAnnotation) {
                annotation = object.annotations[0] as PathAnnotation;
                this.ddlTextPosition.dataSource = this.selectedItem.textProperties.getConnectorTextPositions();
                this.ddlTextPosition.value = this.selectedItem.textProperties.textPosition = null;
                this.ddlTextPosition.dataBind();
                this.ddlTextPosition.value = this.selectedItem.textProperties.textPosition = annotation.alignment;
                this.ddlTextPosition.dataBind();
            }
        }

    };
   
    public rotateChange(args: IRotationEventArgs) {
            this.selectedItem.diagram.rotate(this.selectedItem.diagram.selectedItems.nodes[0], 90);

        let diagram:any = this.selectedItem.diagram;
        if (diagram.selectedItems.nodes.concat(diagram.selectedItems.connectors as object).length === 1) {
            this.selectedItem.nodeProperties.rotateAngle = args.newValue ? args.newValue.rotateAngle : diagram.selectedItems.nodes.concat(diagram.selectedItems.connectors as object)[0].rotateAngle;
        }
    };
    public positionChange(args: any) {
        this.selectedItem.preventPropertyChange = true;
        this.selectedItem.nodeProperties.offsetX = (Math.round(args.newValue.offsetX * 100) / 100);
        this.selectedItem.nodeProperties.offsetY = (Math.round(args.newValue.offsetY * 100) / 100);
        if (args.state === 'Completed') {
            this.selectedItem.isModified = true;
            this.selectedItem.preventPropertyChange = false;
        }
    };
    
    public collectionChange(args: ISelectionChangeEventArgs): void {
        if (args.state === 'Changed') {
            this.selectedItem.isModified = true;
        }
    }
   
    public objectTypeChange(objectType: string): void {
        document.getElementById('diagramPropertyContainer')!.style.display = 'none';
        document.getElementById('nodePropertyContainer')!.style.display = 'none';
        document.getElementById('textPropertyContainer')!.style.display = 'none';
      
        
        switch (objectType) {
            case 'diagram':
                document.getElementById('diagramPropertyContainer')!.style.display = '';
                break;
            case 'node':
                document.getElementById('nodePropertyContainer')!.style.display = '';
                break;
          
                
        }
    };
    public historyChange() {
        // let diagram = (document.getElementById('diagram') as any).ej2_instances[0];
        let diagram:any = this.selectedItem.diagram;
        let toolbarContainer: HTMLDivElement = document.getElementsByClassName('db-toolbar-container')[0] as HTMLDivElement;
        toolbarContainer.classList.remove('db-undo');
        toolbarContainer.classList.remove('db-redo');
        if (diagram.historyManager.undoStack.length > 0) {
            toolbarContainer.classList.add('db-undo');
        }
        if (diagram.historyManager.redoStack.length > 0) {
            toolbarContainer.classList.add('db-redo');
        }
    };
    public diagramClear() {
        this.selectedItem.diagram.clear();
    }

}

export class DiagramPropertyBinding {
    private selectedItem: any;
    private nodeProperties: NodeProperties;
    constructor(selectedItem: SelectorViewModel, nodeProperties: NodeProperties) {
        this.selectedItem = selectedItem;
        this.nodeProperties = nodeProperties;
    }
    public pageOrientationChange(args: any): void {
        if (args.target) {
            var target = args.target;
            let designContextMenu = (document.getElementById('designContextMenu') as any).ej2_instances[0];
            let diagram = this.selectedItem.diagram;
            var items = designContextMenu.items;
            var option = target.id ? target.id : (args.currentTarget.ej2_instances[0].iconCss === 'sf-icon-portrait' ? 'pagePortrait' : 'pageLandscape');
            switch (option) {
                case 'pagePortrait':
                    // diagram.pageSettings.isPortrait = true;
                    // diagram.pageSettings.isLandscape = false;
                    diagram.pageSettings.orientation = 'Portrait';
                    items[0].items[0].iconCss = '';
                    items[0].items[1].iconCss = 'sf-icon-check-tick';
                    document.getElementById('pageLandscape')!.classList.remove('e-active');
                    break;
                case 'pageLandscape':
                    // diagram.pageSettings.isPortrait = false;
                    // diagram.pageSettings.isLandscape = true;
                    diagram.pageSettings.orientation = 'Landscape';
                    items[0].items[0].iconCss = 'sf-icon-check-tick';
                    items[0].items[1].iconCss = '';
                    document.getElementById('pagePortrait')!.classList.remove('e-active');
                    break;
            }
            diagram.dataBind();
        }
    };
    public pageDimensionChange(args:  any): void {
        if (args.event) {
            let pageWidth: number = Number(this.selectedItem.pageSettings.pageWidth);
            let pageHeight: number = Number(this.selectedItem.pageSettings.pageHeight);
            let target: HTMLInputElement = args.event.target as HTMLInputElement;
            if (target.tagName.toLowerCase() === 'span') {
                target = target.parentElement!.children[0] as HTMLInputElement;
            }
            let diagram: Diagram = this.selectedItem.diagram;
            if (target.id === 'numerictextbox_0') {
                pageWidth = parseInt(target.value.split(',').join(''), 10);
            } else {
                pageHeight = parseInt(target.value.replace(/,/g, ''), 10);
            }
            if (pageWidth && pageHeight) {
                if (pageWidth > pageHeight) {
                    this.selectedItem.pageSettings.isPortrait = false;
                    this.selectedItem.pageSettings.isLandscape = true;
                    diagram.pageSettings.orientation = 'Landscape';
                } else {
                    this.selectedItem.pageSettings.isPortrait = true;
                    this.selectedItem.pageSettings.isLandscape = false;
                    diagram.pageSettings.orientation = 'Portrait';
                }
                this.selectedItem.pageSettings.pageWidth = diagram.pageSettings.width = pageWidth;
                this.selectedItem.pageSettings.pageHeight = diagram.pageSettings.height = pageHeight;
                diagram.dataBind();
            }
        }
    };
    public pageBackgroundChange1(args: ColorPickerEventArgs | any): void {
        if (args.currentValue) {
            // let target: HTMLInputElement = args.target as HTMLInputElement; 
            let diagram: Diagram = this.selectedItem.diagram;
            diagram.pageSettings.background = {
                color: args.currentValue.rgba
            };
            diagram.dataBind();
        }
    };
    public pageBreaksChange(args: CheckBoxChangeEventArgs): void {
        if (args.event) {
            this.selectedItem.pageSettings.pageBreaks = args.checked;
            this.selectedItem.diagram.pageSettings.showPageBreaks = args.checked;
        }
    };
    public paperListChange(args: any) {
        document.getElementById('pageDimension')!.style.display = 'none';
        document.getElementById('pageOrientation')!.style.display = '';
        // let diagram = (document.getElementById('diagram') as any).ej2_instances[0];
        let diagram = this.selectedItem.diagram;
        var value = args.value || args.item.value;
        var paperSize = this.selectedItem.utilityMethods.getPaperSize(value);
        var pageWidth = paperSize.pageWidth;
        var pageHeight = paperSize.pageHeight;
        if (pageWidth && pageHeight) {
            if (diagram.pageSettings.orientation === 'Portrait') {
                if (pageWidth > pageHeight) {
                    var temp = pageWidth;
                    pageWidth = pageHeight;
                    pageHeight = temp;
                }
            }
            else {
                if (pageHeight > pageWidth) {
                    var temp = pageHeight;
                    pageHeight = pageWidth;
                    pageWidth = temp;
                }
            }
            diagram.pageSettings.width = pageWidth;
            diagram.pageSettings.height = pageHeight;
        }
        else {
            document.getElementById('pageOrientation')!.style.display = 'none';
            document.getElementById('pageDimension')!.style.display = '';
            diagram.pageSettings.width = 1460;
            diagram.pageSettings.height = 600;
        }
        let designContextMenu = (document.getElementById('designContextMenu') as any).ej2_instances[0];
        this.updatePaperSelection(designContextMenu.items[1], args.value);
        diagram.dataBind();
    };
    public updatePaperSelection(items: any, value: string) {
        for (let i: number = 0; i < items.items.length; i++) {
            if (value === (items.items[i] as any).value) {
                items.items[i].iconCss = 'sf-icon-check-tick';
            }
            else {
                items.items[i].iconCss = '';
            }
        }
    };

    public textPropertyChange(propertyName: string, propertyValue: Object): void {
        if (!this.selectedItem.preventPropertyChange) {
            let diagram: Diagram = this.selectedItem.diagram;
            let selectedObjects: any = diagram.selectedItems.nodes;
            selectedObjects = selectedObjects.concat(diagram.selectedItems.connectors);
            propertyName = propertyName.toLowerCase();
            if (selectedObjects.length > 0) {
                for (let i: number = 0; i < selectedObjects.length; i++) {
                    let node: Object = selectedObjects[i];
                    if ((node as ConnectorModel).type === undefined || (node as ConnectorModel).type !== undefined) {
                        if ((node as any).annotations.length > 0) {
                            for (let j: number = 0; j < (node as any).annotations.length; j++) {
                                let annotation: any | PathAnnotationModel = null;
                                if ((node as any).annotations[j] instanceof ShapeAnnotation) {
                                    annotation = (node as any).annotations[j] as ShapeAnnotationModel;
                                    if (propertyName === 'textposition') {
                                        this.selectedItem.textProperties.textPosition = propertyValue.toString();
                                        annotation.offset = this.selectedItem.utilityMethods.getOffset(propertyValue as string);
                                    }
                                } else if ((node as any).annotations[j] instanceof PathAnnotation) {
                                    annotation = (node as any).annotations[j] as PathAnnotationModel;
                                    if (propertyName === 'textposition') {
                                        this.selectedItem.textProperties.textPosition = propertyValue.toString();
                                        annotation.alignment = this.selectedItem.textProperties.textPosition as AnnotationAlignment;
                                    }
                                }
                                if (propertyName === 'left' || propertyName === 'right' || propertyName === 'center') {
                                    annotation.horizontalAlignment = propertyValue as HorizontalAlignment;
                                    this.selectedItem.utilityMethods.updateHorVertAlign(annotation.horizontalAlignment, annotation.verticalAlignment);
                                } else if (propertyName === 'top' || propertyName === 'bottom') {
                                    annotation.verticalAlignment = propertyValue as VerticalAlignment;
                                    this.selectedItem.utilityMethods.updateHorVertAlign(annotation.horizontalAlignment, annotation.verticalAlignment);
                                } else if (propertyName === 'middle') {
                                    annotation.verticalAlignment = 'Center';
                                    this.selectedItem.utilityMethods.updateHorVertAlign(annotation.horizontalAlignment, annotation.verticalAlignment);
                                } else {
                                    this.updateTextProperties(propertyName, propertyValue, annotation.style);
                                }
                            }
                        } else if ((node as NodeModel).shape && (node as any).shape.type === 'Text') {
                            this.updateTextProperties(propertyName, propertyValue, (node as any).style);
                        }
                    }
                }
                diagram.dataBind();
                this.selectedItem.isModified = true;
            }
        }
    };

    public toolbarTextStyleChange(args: any): void {
        this.textPropertyChange(args.item.tooltipText, false);
    };
    public toolbarTextSubAlignChange(args: any): void {
        let propertyName: string = args.item.tooltipText.replace(/[' ']/g, '');
        this.textPropertyChange(propertyName, propertyName);
    };
    public toolbarTextAlignChange(args: any): void {
        let propertyName: string = args.item.tooltipText.replace('Align ', '');
        if (propertyName === 'Top') {
            propertyName = 'Bottom';
        }
        else if (propertyName === 'Bottom') {
            propertyName = 'Top';
        }
        this.textPropertyChange(propertyName, propertyName);
    }
    public textPositionChange(args: any): void {
        if (args.value !== null) {
            this.textPropertyChange('textPosition', args.value);
        }
    }
    public updateTextProperties(propertyName: string, propertyValue: Object, annotation: TextStyleModel): void {
        switch (propertyName) {
            case 'bold':
                annotation.bold = !annotation.bold;
                this.updateToolbarState('toolbarTextStyle', annotation.bold, 0);
                break;
            case 'italic':
                annotation.italic = !annotation.italic;
                this.updateToolbarState('toolbarTextStyle', annotation.italic, 1);
                break;
            case 'underline':
                this.selectedItem.textProperties.textDecoration = !this.selectedItem.textProperties.textDecoration;
                annotation.textDecoration = annotation.textDecoration === 'None' || !annotation.textDecoration ? 'Underline' : 'None';
                let dec = annotation.textDecoration === 'Underline' ? true : false
                this.updateToolbarState('toolbarTextStyle', dec, 2);
                break;
            case 'aligntextleft':
            case 'aligntextright':
            case 'aligntextcenter':
                annotation.textAlign = propertyValue.toString().replace('AlignText', '') as TextAlign;
                this.selectedItem.utilityMethods.updateTextAlign(annotation.textAlign);
                break;
        }
    };
    public updateToolbarState(toolbarName: string, isSelected: boolean, index: number) {
        let toolbarTextStyle: any = document.getElementById(toolbarName);
        if (toolbarTextStyle) {
            toolbarTextStyle = toolbarTextStyle.ej2_instances[0];
        }
        if (toolbarTextStyle) {
            let cssClass: string = toolbarTextStyle.items[index].cssClass;
            toolbarTextStyle.items[index].cssClass = isSelected ? cssClass + ' tb-item-selected' : cssClass.replace(' tb-item-selected', '');
            toolbarTextStyle.dataBind();
        }
    };
    public download(filename: string) {
        this.selectedItem.utilityMethods.download(this.selectedItem.diagram.saveDiagram(), filename);
    }
}
